import React, { useEffect } from "react";

import AOS from "aos";
import "aos/dist/aos.css";
import "./Home.css";
import NavBar from "./NavBar";
import Footer from "./Footer";
import { Link } from "react-router-dom";
import billboard from "./images/billboard.jpg";
import { DotLottieReact } from "@lottiefiles/dotlottie-react";

export default function Home() {
  // scroll animation
  useEffect(() => {
    AOS.init({ duration: 1800, once: true });
  }, []);

  // post api
  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData(e.target);

    try {
      const response = await fetch(
        "https://identifying-covers-ongoing-pull.trycloudflare.com/api/Home/submit",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            Name: formData.get("name"),
            Number: formData.get("number"),
            Email: formData.get("email"),
            Description: formData.get("Description"),
          }),
        }
      );

      if (response.ok) {
        const result = await response.json();
        alert("Success: " + result.message);
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  return (
    <div className="home">
      <div className="hero">
        <NavBar />
        <video autoPlay muted loop playsInline className="bg-video">
          <source
            src="/videos/4805615-hd_1920_1080_30fps.mp4"
            type="video/mp4"
          />
          متصفحك لا يدعم الفيديو
        </video>

        <div className="blur">
          {" "}
          <div className="content text-black container">
            <div className="info" data-aos="fade-right">
              <p>WE</p>
              <p>HELP</p>
              <p>DEVELOP</p>
              <p>BRANDS</p>
            </div>

            <div className="details" data-aos="zoom-in">
              <p className="">
                <span className=" text-uppercase ">spark </span> is a leading
                BTL marketing agency in the MENA region with over 200 employees,
                offices in Cairo and Dubai, partnerships with over 600 clients,
                and a privately-owned production house. We are proud of our
                reputation and plan to surpass even higher benchmarks in the
                future.
              </p>
              <Link className="shadow__btn">Learn More</Link>{" "}
            </div>
          </div>
        </div>
      </div>

      <div className="about-section">
        <div className="container">
          <div className=" row">
            <div className="about-photo" data-aos="zoom-in">
              <img src={billboard} alt="" />
            </div>
            <div className="info" data-aos="fade-left">
              <h2 className=" text-uppercase">spark</h2>
              <p>
                At Innovation Crew, innovation isn't just a buzzword; it's woven
                into the fabric of everything we do. We're not your typical BTL
                marketing agency. We're the disruptors, the dreamers, and the
                doers.{" "}
              </p>
              <Link class="Btn"></Link>{" "}
            </div>
          </div>
        </div>
      </div>

      <div className="services">
        <div className="services-blur"></div>
        <div className="container overlay">
          <h2 className=" text-uppercase">services</h2>
          <div className="row">
            <div className="service" data-aos="zoom-in">
              <div className="hr"></div>
              <h3>Outdoor Advertising</h3>
            </div>
            <div className="service" data-aos="zoom-in">
              <div className="hr"></div>
              <h3>Billboard Rental</h3>
            </div>
            <div className="service" data-aos="zoom-in">
              <div className="hr"></div>
              <h3>Media Planning & Buying</h3>
            </div>
            <div className="service" data-aos="zoom-in">
              <div className="hr"></div>
              <h3>Design & Printing</h3>
            </div>
            <div className="service" data-aos="zoom-in">
              <div className="hr"></div>
              <h3>Installation & Maintenance</h3>
            </div>
            <div className="service" data-aos="zoom-in">
              <div className="hr"></div>
              <h3>Campaign Managemen</h3>
            </div>
            <div className="service" data-aos="zoom-in">
              <div className="hr"></div>
              <h3>Digital Billboards</h3>
            </div>
            <div className="service" data-aos="zoom-in">
              <div className="hr"></div>
              <h3>Market Research</h3>
            </div>
          </div>
        </div>
      </div>

      <div className="form-section py-5">
        <div className="container">
          <div className="form-container" data-aos="fade-right">
            <h2 className="form-title">Get In Touch</h2>
            <p className="form-subtitle">
              We'll get back to you as soon as possible
            </p>

            <form className="form" onSubmit={handleSubmit}>
              <div className="form-group">
                <input
                  type="text"
                  id="name"
                  name="name"
                  placeholder=" "
                  required
                />
                <label htmlFor="name">Name</label>
              </div>

              <div className="form-group">
                <input
                  type="tel"
                  id="number"
                  name="number"
                  placeholder=" "
                  required
                />
                <label htmlFor="number">Phone Number</label>
              </div>

              <div className="form-group">
                <input
                  type="email"
                  id="email"
                  name="email"
                  placeholder=" "
                  required
                />
                <label htmlFor="email">Email Address</label>
              </div>

              <div className="form-group">
                <textarea
                  id="textarea"
                  name="message"
                  placeholder=" "
                  rows={4}
                  required
                />
                <label htmlFor="textarea">How Can We Help You?</label>
              </div>

              <button className="form-submit-btn" type="submit">
                Send Message
              </button>
            </form>
          </div>

          <div className="form-animation" data-aos="fade-left">
            <DotLottieReact
              src="https://lottie.host/9fa0dd69-b498-4cce-b8c9-88f978716815/OvvIBgTUjp.lottie"
              loop
              autoplay
            />
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}
